module.exports = __webpack_public_path__ + "static/img/bg3.0beb6bea.png";